import React, { useEffect, useState } from 'react';
import MessageCard from '../../../components/card/message-card';
import MicroLoader from '../../../components/UI/loader/micro-loader';
import { RentalExtensionRequest } from '../../../services/entities/requests/rental-extension-request';
import { doExtendRentalFunctionality } from '../../../shared/api/common-api';
import { activeCurrentLink } from '../../../shared/utility';
import { RequestHandleType } from '../../../shared/utility/enum-utility';
import AdditionalChargeDetails from './component/additional-charge-details';
import ExtendRentalCtrls from './component/extend-rental-ctrls';
import "./rental-extension.scss";

function ExtensionHistory() {
    const [formValue, setFormValue] = useState(null);
    const [loader, setLoader] = useState(false);
    const [extensionResponse, setExtensionResponse] = useState(null);

    useEffect(() => {
        activeCurrentLink("rentalMenu");
    }, []);
    const validateForm = () => {
        if (formValue?.firstName
            && formValue?.lastName
            && formValue?.email
            && formValue?.rentalAgreementNum) {
            return true
        }
        return false;
    }
    const onChange = (data, name) => {
        const tempData = { ...formValue };
        tempData[name] = data;
        setFormValue(tempData);
    }
    const onClear = () => {
        setFormValue(null);
        setExtensionResponse(null);
    }
    const getRentalHistory = async () => {
        setLoader(true);
        const request = new RentalExtensionRequest({
            rentalExtension: { ...formValue },
            details: true
        });
        const response = await doExtendRentalFunctionality(request, RequestHandleType.RESPONSE_ONLY);
        if (response) {
            setExtensionResponse(response);
        }
        setLoader(false);
    }
    return (
        <div className='extension-history-cont'>
            <h1>Extension History</h1>
            <hr />
            <div className='flex-row gap-2'>
                <div className='flex-column retrive-form card'>
                    <h2>Retreive Rental</h2>
                    <hr />
                    <ExtendRentalCtrls formValue={formValue} onChange={onChange} />
                    <hr />
                    <div className='btn-container m-0 justify-content-center'>
                        <button className='btn btn-outline-danger' onClick={() => onClear()}>Clear</button>
                        <button className='btn btn-yellow-default' onClick={() => getRentalHistory()} disabled={!validateForm()}>Retrieve</button>
                    </div>
                </div>
                <div className='flex-column extension-history' style={{ height: "75vh", overflowX: "auto" }}>
                    <div className='history-title'>
                        <h2>History</h2>
                        <hr />
                    </div>
                    {!loader && ((extensionResponse?.message && extensionResponse?.message === "ERROR")
                        || (extensionResponse && !extensionResponse?.rentalExtensions)) ?
                        <MessageCard
                            contClasses="msg-error-block"
                            title="No extensions found!"
                            message={extensionResponse?.message === "ERROR" ? extensionResponse?.message : ""}
                            iconClass="fas fa-check-circle"
                        /> : ""}
                    {loader ? <MicroLoader /> : ""}
                    {extensionResponse?.rentalExtensions?.map((data, i) => {
                        return <AdditionalChargeDetails key={data?.returnDate} showLoader={loader}
                            rentalExtension={data} isExpand={extensionResponse?.rentalExtensions.length === 1 && true}
                            contClasses={i === 0 ? "first-element" : ""}
                        />
                    })
                    }
                    {!loader && !extensionResponse && <div className='no-extend-history-found'>No Record Found</div>}
                </div>
            </div>
        </div>
    )
}

export default ExtensionHistory